export const getValuesFromInitialAndDefault = (initialValues: any, defaultValues: any, ignoreValues?:string[],needZeros?:boolean) => {
    const values: Record<string, any> = {};
    Object.keys(defaultValues).forEach((key) => {
        const initialValue = initialValues && initialValues[key];
        const defaultValue = defaultValues[key];

        values[key] = defaultValue;
        if (needZeros) {
            if (initialValue||initialValue>-1 && !(ignoreValues && ignoreValues.some(x => x === key)) ) values[key] = initialValue;
        }
        else{
            if (initialValue && !(ignoreValues && ignoreValues.some((x) => x === key))) values[key] = initialValue;            
        } 
    });    

    return values;
};
export const setDefaultInsteadOfNullByDataType = (object:any, datatype:string, defaultValue:any, keysToIgnore:Array<string>) =>{
    for (const key in object) {
        if (typeof object[key] === datatype && object[key] === defaultValue && keysToIgnore.indexOf(key) === -1 ) {
            object[key] = null;
        }
    }
    return object;
}